import {Dispatch} from "redux";
import {Actions} from '../actions/myListForFlyerActions';
import {httpClient} from "../../httpClient";
import {
    GetMyListForFlyerDto,
    IFlyerItemsListDto,
    IFlyerItemsListForStoreDto,
    IFlyerRuntimePageSpotPromo
} from "../../dtos/flyer";
import {ErrorDtoFactory} from "../../dtos/errorDto";
import {ActionType} from "../actionTypes/actionTypes";
import envManager from "../../com/envManager/EnvManager";

export const createMyListForFlyer = (myListData: IFlyerItemsListDto) => {
    return async (
        dispatch: Dispatch<Actions>
    ) => {
        dispatch({
            type: ActionType.POST_MY_LIST_FOR_FLYER_START,
        });

        try {
            const config = {
                headers: {
                    "Content-Type": "application/json",
                },
            };

            let result = await httpClient.post<number>(
                "Flyers/CreateFlyerItemList",
                myListData,
                config
            );
            let data = result.data;
            dispatch({
                type: ActionType.POST_MY_LIST_FOR_FLYER_SUCCESS,
                payload: data
                // payload: flippingFlyerPayload,
            });

            dispatch({
                type: ActionType.POST_MY_LIST_FOR_FLYER_COMPLETE,
                // payload: '',
            });

        } catch (err) {
            dispatch({
                type: ActionType.POST_MY_LIST_FOR_FLYER_ERROR,
                payload: ErrorDtoFactory.createErrorDto(err),
            });
        }
    };
};

export const createMyListForStore = (myListData: IFlyerItemsListForStoreDto) => {
    return async (
        dispatch: Dispatch<Actions>
    ) => {
        dispatch({
            type: ActionType.POST_MY_LIST_FOR_FLYER_START,
        });

        try {
            const config = {
                headers: {
                    "Content-Type": "application/json",
                },
            };
            let url = `${envManager.storeServerAddress}/api/VirtualStoreShowroom/CreateStoreItemList`;
            let result = await httpClient.post(
                url,
                myListData,
                config
            );
            let data = result.data;
            dispatch({
                type: ActionType.POST_MY_LIST_FOR_FLYER_SUCCESS,
                payload: data.data.storeItemListId,
                // payload: flippingFlyerPayload,
            });
            localStorage.setItem("StoreShopperId", `${data.data.shopperId}`);
            dispatch({
                type: ActionType.POST_MY_LIST_FOR_FLYER_COMPLETE,
                // payload: '',
            });

        } catch (err) {
            dispatch({
                type: ActionType.POST_MY_LIST_FOR_FLYER_ERROR,
                payload: ErrorDtoFactory.createErrorDto(err),
            });
        }
    };
};

export const getMyListForFlyer = (myListId: number, flyerId: number) => {

    return async (
        dispatch: Dispatch<Actions>
    ) => {
        dispatch({
            type: ActionType.GET_MY_LIST_FOR_FLYER_START,
        });

        try {
            const config = {
                headers: {
                    "Content-Type": "application/json",
                },
            };
            let result = await httpClient.get(
                `Flyers/GetFlyerItemList/${myListId}?flyerId=${flyerId}`,
                config
            );
            let data: GetMyListForFlyerDto = {...result.data};
            if(data.items && data.items?.length > 0) {
                const dummyPromoForAllItemsWhichDontHavePromo: IFlyerRuntimePageSpotPromo = {
                    items: [...data.items] || [],
                    promoBuyAmount: null,
                    promoBuyQty: 1,
                    promoGetAmountOff: null,
                    promoGetPctOff: null,
                    promoSalePrice: 0,
                    promoSaleTypeCode: null,
                    promoPctAt: null,
                    promoRegularPrice: 0,
                    promoId: null,
                    promoSellingUnitId: null,
                    promoDisplayCaption1: ``,
                    promoDisplayCaption2: ``,
                    promoVisualImpairmentAudio: ``,
                    promoLandingPage: ``,
                    promoKeywords: ``,
                    promoImageThumbnail: null,
                    promoImage: null,
                    promoImageSelection: null,
                    promoValidFromUtc: ``,
                    promoValidToUtc: ``
                }
                data.promos?.push(dummyPromoForAllItemsWhichDontHavePromo);
            }
            dispatch({
                type: ActionType.GET_MY_LIST_FOR_FLYER_SUCCESS,
                payload: {
                    myListId: myListId,
                    myList: data
                }
            });

            dispatch({
                type: ActionType.GET_MY_LIST_FOR_FLYER_COMPLETE,
            });

        } catch (err) {
            dispatch({
                type: ActionType.GET_MY_LIST_FOR_FLYER_ERROR,
                payload: ErrorDtoFactory.createErrorDto(err),
            });
        }
    };
};

export const getMyListForStore = (myListId: number) => {

    return async (
        dispatch: Dispatch<Actions>
    ) => {
        dispatch({
            type: ActionType.GET_MY_LIST_FOR_FLYER_START,
        });

        try {
            const config = {
                headers: {
                    "Content-Type": "application/json",
                },
            };
            let url = `${envManager.storeServerAddress}/api/VirtualStoreShowroom/GetStoreItemList/${myListId}`;


            let result = await httpClient.get(
                url,
                config
            );
            let data: GetMyListForFlyerDto = {...result.data.data};
            if(data.items && data.items?.length > 0) {
                const dummyPromoForAllItemsWhichDontHavePromo: IFlyerRuntimePageSpotPromo = {
                    items: [...data.items] || [],
                    promoBuyAmount: null,
                    promoBuyQty: 1,
                    promoGetAmountOff: null,
                    promoGetPctOff: null,
                    promoSalePrice: 0,
                    promoSaleTypeCode: null,
                    promoPctAt: null,
                    promoRegularPrice: 0,
                    promoId: null,
                    promoSellingUnitId: null,
                    promoDisplayCaption1: ``,
                    promoDisplayCaption2: ``,
                    promoVisualImpairmentAudio: ``,
                    promoLandingPage: ``,
                    promoKeywords: ``,
                    promoImageThumbnail: null,
                    promoImage: null,
                    promoImageSelection: null,
                    promoValidFromUtc: ``,
                    promoValidToUtc: ``
                }
                data.promos?.push(dummyPromoForAllItemsWhichDontHavePromo);
            }

            dispatch({
                type: ActionType.GET_MY_LIST_FOR_FLYER_SUCCESS,
                payload: {
                    myListId: myListId,
                    myList: data
                }
            });

            dispatch({
                type: ActionType.GET_MY_LIST_FOR_FLYER_COMPLETE,
            });

        } catch (err) {
            dispatch({
                type: ActionType.GET_MY_LIST_FOR_FLYER_ERROR,
                payload: ErrorDtoFactory.createErrorDto(err),
            });
        }
    };
};
